import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const VimeoIcon = ({ color = 'currentColor', className = null }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            fill={color}
            d="M15.9923 4.20373C15.9209 5.75966 14.8336 7.89061 12.7303 10.5966C10.5545 13.4255 8.71383 14.84 7.20833 14.84C6.27477 14.84 5.48573 13.979 4.84122 12.2571L3.54974 7.52284C3.07004 5.80086 2.55591 4.93988 2.00734 4.93988C1.88926 4.93988 1.47045 5.19264 0.752751 5.69447L0 4.72401C0.78965 4.0303 1.56762 3.33659 2.3339 2.64288C3.38799 1.73392 4.17887 1.25484 4.70654 1.20564C5.95005 1.08264 6.71633 1.93379 7.00538 3.75909C7.31534 5.72707 7.53058 6.94906 7.65112 7.42506C8.01151 9.05602 8.40695 9.87088 8.83744 9.86965C9.17077 9.86965 9.67322 9.34076 10.3448 8.28297C11.0164 7.22519 11.3755 6.42016 11.4223 5.8679C11.5182 4.95525 11.159 4.49831 10.3448 4.49708C9.93631 4.50345 9.53337 4.59258 9.16031 4.75907C9.94873 2.18594 11.4512 0.933814 13.6676 1.00269C15.3121 1.05312 16.087 2.12013 15.9923 4.20373Z"
        />
    </svg>
);

VimeoIcon.propTypes = propTypes;

export default VimeoIcon;
